import {ContentSubmissionKind} from './types';
import {lookupNetworkName} from './shell/networkName';

const KIND_FALLBACK: Record<ContentSubmissionKind, string> = {
  photo: 'Photos',
  video: 'Videos',
  blog: 'Blogs',
  mixed_media: 'Story Uploads',
};

export default function deliverableLabel(
  deliverableKind: string | null,
  kind: ContentSubmissionKind
): string {
  if (!deliverableKind) return KIND_FALLBACK[kind];
  const [network, ...rest] = deliverableKind.split('_');
  return `${lookupNetworkName(network)} ${rest.join(' ') || 'post'}`;
}
